import { render } from "./ResumenBuscador.vue?vue&type=template&id=02645e00&scoped=true"
import script from "./ResumenBuscador.vue?vue&type=script&lang=js"
export * from "./ResumenBuscador.vue?vue&type=script&lang=js"

import "./ResumenBuscador.vue?vue&type=style&index=0&id=02645e00&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02645e00"]])

export default __exports__